import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ModalDetalleCotizacionComponent, ModalDetalleCotizacionData } from '../modal-detalle-cotizacion/modal-detalle-cotizacion.component';
import { PopUpMensajeComponent, PopUpMensajeData } from '../../../contratante-page/components/pop-up-mensaje/pop-up-mensaje.component';
import { Subject, Subscription, forkJoin, of } from 'rxjs';
import { catchError, concatMap, debounceTime, finalize, map } from 'rxjs/operators';
import { ConsultarCotizacionService } from '../../../../../../services/cotizador-cotizacion/consultar-cotizacion.service';
import { ConsultarTarifasIndividualesService } from '../../../../../../services/cotizador-contratante/consultar-tarifas-individuales.service';
import { ConsultarLineasGruposProgramasService } from '../../../../../../services/cotizador-programas/consultar-lineas-grupos-programas.service';
import { ConsultarAsociadoService } from '../../../../../../services/cotizador-contratante/consultar-asociado.service';
import { ConsultarTarifasIndividualesResponse } from '../../../../../../models/cotizador-contratante/consultar-tarifas-individuales/response/consultar-tarifas-individuales-response.model';
import { ConsultarTarifasIndividualesValoresResponse } from '../../../../../../models/cotizador-contratante/consultar-tarifas-individuales-valores/response/consultar-tarifas-individuales-valores-response.model';
import {
  CampaniaDetalleItem,
  ConsultarCampaniaDetalleHttpResponse
} from '../../../../../../models/cotizador-cotizacion/consultar-campania-detalle/response/consultar-campania-detalle-response.model';

export interface ResumenCotizacionRow {
  idBeneficiario?: number | null;
  idBenPrograma?: number | null;
  nombre: string;
  precioBaseMensual: number;
  precioBaseMensualAnexos: number;
  aplicaAnexos?: boolean,
  descuentosCampana: number;
  pagoProporcionalIngresoAnticipado: number;
  descuentoProntoPago: number;
  valorTotalPeriodoProntoPago: number;
  precioBaseTarifaAsociado: number;
  modalLineaNegocio: string;
  modalPrograma: string;
  modalTarifaMensual: number;
  modalDescripcionTarifa: string;
  /** Código de la tarifa elegida. */
  modalTarifaCodigo?: string;
  modalCampaniaCodigo: string;
  modalCampaniaNombre: string;
  modalCampaniaInicioVigencia: string;
  modalCampaniaFinVigencia: string;
  /** PK COTIZACION_CAMPANIA para detalle de descuentos por mes (RQ005). */
  idCotizacionCampania: number | null;
  beneficiarioEdad?: number;
  beneficiarioGenero?: string;
  beneficiarioParentesco?: string;
  /** Cuota de inscripción del beneficiario cuando APLICACION_CUOTA = POR_BENEFICIARIO. */
  cuotaInscripcionValor?: number;
}

export interface EstadoInicialPrograma {
  proporcionalidad: 'SI' | 'NO';
  fechaIngreso: string | null;
  diaCorte: number | null;
  aplicaCuotaInscripcion: 'SI' | 'NO';
  valorCuotaInscripcion: number;
  mesesProntoPago: number;
  aplicaTarifaAsociado: boolean;
}

export interface EstadoLiquidacionPrograma {
  programaId: string;
  lineaNegocio: string;
  proporcionalidad: 'SI' | 'NO';
  fechaIngreso: string | null;
  diaCorte: number | null;
  diasProporcionalidad: number;
  aplicaCuotaInscripcion: 'SI' | 'NO';
  valorCuotaInscripcion: number;
  /** true cuando getCuota devolvió APLICACION_CUOTA = POR_BENEFICIARIO. */
  aplicacionCuotaPorBeneficiario: boolean;
  mesesProntoPago: number;
  columnaValorTabla: 'periodoPronto' | 'totalSimple' | 'ninguna';
  aplicaTarifaAsociado: boolean;
  pCuotaInscripcion: string;
  pPagoProporcionalAnticipado: string;
  pPrecioBaseAnexos: string;
  rows: ResumenCotizacionRow[];
  pTarifaAsociado: string;
}

/** Operación asíncrona que el resumen debe reportar al contenedor durante la carga inicial. */
export interface CalculoPendientePrograma {
  programaId: string;
  operacion: string;
  pendiente: boolean;
  revision: number;
}

interface CotizacionContratanteActual {
  idCotizacion: number | string;
  tipoDocumento?: string;
  numeroDocumento?: string;
}

@Component({
  selector: 'app-resumen-cotizacion-programa',
  templateUrl: './resumen-cotizacion-programa.component.html',
  styleUrls: ['./resumen-cotizacion-programa.component.css']
})
export class ResumenCotizacionProgramaComponent implements AfterViewInit, OnInit, OnChanges, OnDestroy {
  @Input() programaId: string = '';
  @Input() lineaNegocio: string = 'MEDICINA INTEGRAL';
  @Input() programaTitulo: string = 'Programa ORO PLUS - MI';
  @Input() rowsData?: ResumenCotizacionRow[];
  @Input() estadoInicial?: EstadoInicialPrograma;
  @Input() bloqueoInteraccion = false;
  @Input() cargaRevision = 0;
  @Output() estadoLiqudacionChange = new EventEmitter<EstadoLiquidacionPrograma>();
  @Output() calculoPendienteChange = new EventEmitter<CalculoPendientePrograma>();

  expanded = false;
  comparar = false;

  ocultarProporcionalidad = false;
  /**
   * `periodoPronto`: % pronto + valor periodo (no colectivo).
   * `totalSimple`: solo columna VALOR TOTAL (mes 1 + campaña) — ventas nuevas plan C/GA/AG.
   * `ninguna`: sin columnas de pronto — inclusión.
   */
  columnaValorTabla: 'periodoPronto' | 'totalSimple' | 'ninguna' = 'periodoPronto';

  proporcionalidad: 'SI' | 'NO' = 'NO';
  cuotaInscripcion: 'SI' | 'NO' = 'NO';
  fechaIngreso: Date | null = null;
  /** Día de corte elegido por el cliente (1–30). */
  corte: number | null = null;
  valorPagarCuotaInscripcion = 0;
  /** true si getCuota indica APLICACION_CUOTA = POR_BENEFICIARIO (valor por fila). */
  aplicacionCuotaPorBeneficiario = false;
  prontoPagoMeses = 12;
  /** Apagado al cargar; legacy + valores solo al activar el toggle. */
  mostrarTarifaAsociado = false;
  pComparativo: string = '0';

  searchText = '';
  private readonly KEY_DATOS_CONTRATANTE = 'datosRQ002_Contratante';
  private readonly KEY_COTIZACION_ACTUAL = 'cotizacion_contratante_actual';
  private readonly KEY_COTIZACION_CREADA = 'cotizacion_creada_desde_contratante';
  private readonly KEY_COTIZACION_PRECARGADA = 'cotizacion_precargada';
  private readonly KEY_COTIZACION_CARGADA = 'cotizacion_cargada';
  private readonly KEY_PROGRAMAS_CONTRATANTE = 'programas_contratante';

  @ViewChild(MatPaginator) paginator?: MatPaginator;

  dataSource = new MatTableDataSource<ResumenCotizacionRow>([]);
  private sourceRows: ResumenCotizacionRow[] = [];
  private estadoPersistidoAplicado = false;

  constructor(
    private dialog: MatDialog,
    private consultarCotizacionService: ConsultarCotizacionService,
    private consultarTarifasIndividualesService: ConsultarTarifasIndividualesService,
    private consultarLineasGruposProgramasService: ConsultarLineasGruposProgramasService,
    private consultarAsociadoService: ConsultarAsociadoService
  ) { }

  private static readonly programaHomologoAsociadoCache = new Map<string, string>();
  /** Cache programa → código de grupo (parte antes de "|") para pronto pago. */
  private static readonly grupoProgramaXProgramaCache = new Map<string, string>();

  private static readonly DIA_CORTE_MIN = 1;
  private static readonly DIA_CORTE_MAX = 30;
  private static readonly DIAS_MES_COMPLETO_PROPORCIONALIDAD = 30;

  private static readonly compararSeleccionadosPorLinea: Map<string, Set<string>> = new Map();
  private static readonly compararCambios$ = new Subject<void>();
  private static readonly KEY_COMPARAR_STORAGE = 'rq006_comparar_programas_por_linea';
  private static readonly KEY_PARAMETROS_JASPER_STORAGE =
    'parametros_jasper_individual';
  private compararCambiosSub?: Subscription;
  /** Subject para debounce de recalcularProntoPagoEnTabla: colapsa múltiples ngOnChanges en una única ráfaga de HTTP. */
  private readonly _prontoPagoSubject = new Subject<void>();
  private _prontoPagoSub?: Subscription;
  private readonly operacionesPendientes = new Set<string>();
  private _prontoPagoSolicitud = 0;
  /** En edición, el recálculo solo llena filas que todavía no tienen pronto pago. */
  private _soloProntoPagoFaltante = false;
  private _cuotaSolicitud = 0;
  private _tarifaSolicitud = 0;

  static resetCompararMock(): void {
    ResumenCotizacionProgramaComponent.compararSeleccionadosPorLinea.clear();
    ResumenCotizacionProgramaComponent.cargarCompararDesdeStorage();
  }

  static getCompararCount(lineaNegocio: string): number {
    return ResumenCotizacionProgramaComponent.compararSeleccionadosPorLinea.get(lineaNegocio)?.size ?? 0;
  }

  static aplicarCompararDesdeBackend(payload: Record<string, string[]>): void {
    ResumenCotizacionProgramaComponent.compararSeleccionadosPorLinea.clear();
    Object.entries(payload ?? {}).forEach(([linea, ids]) => {
      if (!Array.isArray(ids)) return;
      const valid = ids
        .map((id) => String(id ?? '').trim())
        .filter(Boolean)
        .slice(0, 2);
      if (!valid.length) return;
      ResumenCotizacionProgramaComponent.compararSeleccionadosPorLinea.set(linea, new Set(valid));
    });
    ResumenCotizacionProgramaComponent.guardarCompararEnStorage();
    ResumenCotizacionProgramaComponent.compararCambios$.next();
  }

  ngOnInit(): void {
    ResumenCotizacionProgramaComponent.cargarCompararDesdeStorage();
    this.calcularOcultamientosMockVisual();
    this.syncCompararFromMock();
    this.compararCambiosSub = ResumenCotizacionProgramaComponent.compararCambios$.subscribe(() => {
      this.syncCompararFromMock();
    });
    // Debounce: múltiples ngOnChanges en el mismo tick se colapsan en una única ejecución HTTP.
    this._prontoPagoSub = this._prontoPagoSubject.pipe(debounceTime(0)).subscribe(() => {
      this._ejecutarRecalcularProntoPago();
    });

    // En edición se conservan los valores persistidos.
    // Solo se calcula automáticamente durante la creación.
    if (
      this.sourceRows &&
      this.sourceRows.length > 0 &&
      !this.estadoInicial
    ) {
      this.recalcularProntoPagoEnTabla();
    }

    if (!Array.isArray(this.rowsData) || this.rowsData.length === 0) {
      this.emitirEstadoLiquidacion();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['cargaRevision'] &&
      !changes['cargaRevision'].isFirstChange()
    ) {
      this.operacionesPendientes.clear();
      this.estadoPersistidoAplicado = false;
    }
    if (changes['rowsData']) {
      const prev = (changes['rowsData'].previousValue ?? []) as ResumenCotizacionRow[];
      const curr = (changes['rowsData'].currentValue ?? []) as ResumenCotizacionRow[];

      if (!changes['rowsData'].isFirstChange() && this.mismaIdentidadDeFilas(prev, curr)) {
        const currMap = new Map(curr.map(r => [this.keyFila(r), r]));
        this.sourceRows = this.sourceRows.map((r) => {
          const updated = currMap.get(this.keyFila(r));
          return updated
            ? {
              ...r,
              descuentosCampana: updated.descuentosCampana,
              precioBaseMensualAnexos: Number(
                updated.precioBaseMensualAnexos || 0,
              ),
              aplicaAnexos: updated.aplicaAnexos === true
            }
            : r;
        });
        this.dataSource.data = [...this.sourceRows];
        this.emitirEstadoLiquidacion();
        return;
      }

      this.aplicarRows();
      // Restaurar parámetros guardados solo en modo edición
      if (this.estadoInicial) {
        this.aplicarEstadoInicialInterno();
      }
    }
    if (changes['estadoInicial'] && !changes['estadoInicial'].isFirstChange() && this.estadoInicial && this.sourceRows.length > 0) {
      this.aplicarEstadoInicialInterno();
    }
  }

  get toggleDeshabilitadoComparar(): boolean {
    const linea = (this.lineaNegocio ?? '').trim() || 'MEDICINA INTEGRAL';
    const count = ResumenCotizacionProgramaComponent.getCompararCount(linea);
    // Solo se "deshabilita visualmente" cuando ya hay 2 seleccionados y este programa actualmente está apagado.
    return (!this.bloqueoInteraccion && count >= 2 && !this.comparar) ? true : false;
  }

  get displayedColumns(): string[] {
    const columns: string[] = [
      'nombre',
      'precioBaseMensual'
    ];

    if (this.mostrarPrecioBaseMensualAnexos) {
      columns.push('precioBaseMensualAnexos');
    }

    columns.push('descuentosCampana');

    if (!this.ocultarProporcionalidad && this.proporcionalidad === 'SI') {
      columns.push('pagoProporcionalIngresoAnticipado');
    }

    if (this.cuotaInscripcion === 'SI') {
      columns.push('cuotaInscripcion');
    }

    if (this.columnaValorTabla === 'periodoPronto') {
      columns.push('descuentoProntoPago', 'valorTotalPeriodoProntoPago');
    }

    if (this.mostrarTarifaAsociado) {
      columns.push('precioBaseTarifaAsociado');
    }
    columns.push('acciones');
    return columns;
  }

  ngAfterViewInit(): void {
    if (this.paginator) {
      this.dataSource.paginator = this.paginator;
      this.paginator.pageSize = 10;
    }
  }

  toggleExpanded(): void {
    this.expanded = !this.expanded;
  }

  onCompararChanged(checked: boolean): void {
    // Mock UI: limita a 2 programas por lineaNegocio sin usar `programas_contratante`.
    const id = (this.programaId ?? '').trim();
    const linea = (this.lineaNegocio ?? '').trim() || 'MEDICINA INTEGRAL';
    if (!id) {
      this.comparar = false;
      this.pComparativo = '0';
      return;
    }

    const isChecked = !!checked;
    const existing = ResumenCotizacionProgramaComponent.compararSeleccionadosPorLinea.get(linea) ?? new Set<string>();

    if (isChecked) {
      // Si ya existen 2 seleccionados, no permitir un 3ro (y mostrar popup).
      if (!existing.has(id) && existing.size >= 2) {
        this.dialog.open(PopUpMensajeComponent, {
          width: '500px',
          maxWidth: '90vw',
          disableClose: true,
          data: {
            titulo: 'Advertencia',
            texto: 'Solo se pueden comparar dos programas.',
            tipoIcono: 'warning',
            textoBoton: 'ACEPTAR'
          } as PopUpMensajeData
        });

        this.comparar = false;
        this.pComparativo = '0';
        ResumenCotizacionProgramaComponent.compararCambios$.next();
        return;
      }

      existing.add(id);
      ResumenCotizacionProgramaComponent.compararSeleccionadosPorLinea.set(linea, existing);
      ResumenCotizacionProgramaComponent.guardarCompararEnStorage();
      this.comparar = true;
      this.pComparativo = '1';
      ResumenCotizacionProgramaComponent.compararCambios$.next();
      return;
    }

    // unchecked
    existing.delete(id);
    if (existing.size === 0) {
      ResumenCotizacionProgramaComponent.compararSeleccionadosPorLinea.delete(linea);
    } else {
      ResumenCotizacionProgramaComponent.compararSeleccionadosPorLinea.set(linea, existing);
    }
    ResumenCotizacionProgramaComponent.guardarCompararEnStorage();
    this.comparar = false;
    this.pComparativo = '0';
    ResumenCotizacionProgramaComponent.compararCambios$.next();
  }

  private syncCompararFromMock(): void {
    const set = ResumenCotizacionProgramaComponent.compararSeleccionadosPorLinea.get(this.lineaNegocio);
    this.comparar = !!set?.has(this.programaId);
    // Refresca almacenamiento para mantener sincronizada la key al re-renderizar.
    ResumenCotizacionProgramaComponent.guardarCompararEnStorage();
  }

  ngOnDestroy(): void {
    this.compararCambiosSub?.unsubscribe();
    this._prontoPagoSub?.unsubscribe();
    this._prontoPagoSubject.complete();
  }

  private calcularOcultamientosMockVisual(): void {
    // Reglas visuales basadas en localStorage (sin usar programas_contratante).
    const tipoSolicitud = (localStorage.getItem('tipoSolicitud') ?? '').toString().trim();
    const tipoPlan = (localStorage.getItem('tipoPlan') ?? '').toString().trim().toUpperCase();

    this.ocultarProporcionalidad = false;
    this.columnaValorTabla = 'periodoPronto';

    if (tipoSolicitud === '1') {
      if (['C', 'GA', 'AG'].includes(tipoPlan)) {
        this.ocultarProporcionalidad = true;
        this.columnaValorTabla = 'totalSimple';
        this.proporcionalidad = 'NO';
      }
    } else if (tipoSolicitud === '2') {
      this.columnaValorTabla = 'ninguna';
    }
    // Durante la edición se conservan los valores persistidos.
    // Estos cálculos se ejecutan automáticamente solo durante la creación.
    if (!this.estadoInicial) {
      this.recalcularPagoProporcionalEnTabla();
      this.recalcularProntoPagoEnTabla();
    }
  }

  /** Encabezado columna de importe: colectivo = VALOR TOTAL; si no, periodo pronto pago. */
  get etiquetaColumnaValorTotal(): string {
    return this.columnaValorTabla === 'totalSimple'
      ? 'VALOR TOTAL'
      : 'VALOR TOTAL PERIODO PRONTO PAGO';
  }

  buscar(): void {
    const query = this.normalize(this.searchText);
    if (!query) {
      this.restablecerTabla();
      return;
    }
    const tokens = query.split(/\s+/).filter(Boolean);
    const filtered = this.sourceRows.filter((item) => {
      const searchable = this.normalize([
        item.nombre,
        item.precioBaseMensual.toString(),
        item.precioBaseMensualAnexos.toString(),
        item.descuentosCampana.toString(),
        item.pagoProporcionalIngresoAnticipado.toString(),
        item.descuentoProntoPago.toString(),
        item.valorTotalPeriodoProntoPago.toString(),
        item.precioBaseTarifaAsociado.toString()
      ].join(' '));
      return tokens.every((token) => searchable.includes(token));
    });
    this.dataSource.data = filtered;
    this.paginator?.firstPage();
  }

  limpiar(): void {
    this.searchText = '';
    this.restablecerTabla();
  }

  /**
   * Día del mes (1-31) desde Date o Moment (MomentDateAdapter en app-cotizador).
   */
  private obtenerDiaDelMes(fecha: Date | null): number {
    if (!fecha) {
      return 0;
    }
    const f = fecha as { date?: () => number; getDate?: () => number };
    if (typeof f.date === 'function') {
      return f.date();
    }
    if (typeof f.getDate === 'function') {
      return f.getDate();
    }
    return 0;
  }

  /** Mes calendario 0-11 (Date o Moment). */
  private obtenerMesDelAnio(fecha: Date | null): number {
    if (!fecha) {
      return 0;
    }
    const f = fecha as { month?: () => number; getMonth?: () => number };
    if (typeof f.month === 'function') {
      return f.month();
    }
    if (typeof f.getMonth === 'function') {
      return f.getMonth();
    }
    return 0;
  }

  /** Año calendario (Date o Moment). */
  private obtenerAnioDelMes(fecha: Date | null): number {
    if (!fecha) {
      return 0;
    }
    const f = fecha as { year?: () => number; getFullYear?: () => number };
    if (typeof f.year === 'function') {
      return f.year();
    }
    if (typeof f.getFullYear === 'function') {
      return f.getFullYear();
    }
    return 0;
  }

  /** Fecha local sin hora (evita desfases por zona al comparar días). */
  private normalizarFechaLocal(fecha: Date): Date {
    return new Date(
      this.obtenerAnioDelMes(fecha),
      this.obtenerMesDelAnio(fecha),
      this.obtenerDiaDelMes(fecha)
    );
  }

  /**
   * Fecha de corte efectiva: mismo mes si Di < Dc; mes siguiente (m++) si Dc < Di.
   * El día se acota al último día del mes destino (p. ej. febrero).
   */
  private construirFechaCorteEfectiva(fechaIngreso: Date, diaCorte: number): Date {
    const diaIngreso = this.obtenerDiaDelMes(fechaIngreso);
    let anio = this.obtenerAnioDelMes(fechaIngreso);
    let mes = this.obtenerMesDelAnio(fechaIngreso);
    if (diaIngreso > diaCorte) {
      mes += 1;
      if (mes > 11) {
        mes = 0;
        anio += 1;
      }
    }
    const ultimoDiaMes = new Date(anio, mes + 1, 0).getDate();
    const dia = Math.min(diaCorte, ultimoDiaMes);
    return new Date(anio, mes, dia);
  }

  /** Días calendario entre dos fechas locales (hasta − desde). */
  private diferenciaDiasCalendario(desde: Date, hasta: Date): number {
    const msPorDia = 24 * 60 * 60 * 1000;
    const diff = hasta.getTime() - desde.getTime();
    if (!Number.isFinite(diff) || diff <= 0) {
      return 0;
    }
    return Math.round(diff / msPorDia);
  }

  /**
   * Días de proporcionalidad hasta el día de corte efectivo (inclusive del día de ingreso).
   * - Di === Dc → 30 días (regla de negocio).
   * - En otro caso → diferencia calendario entre ingreso y corte efectivo + 1
   *   (cuenta el día de ingreso; mismo mes o mes siguiente si Dc < Di).
   */
  private normalizarDiaCorte(value: unknown): number | null {
    const n = Math.floor(Number(value));
    if (!Number.isFinite(n)) {
      return null;
    }
    if (n < ResumenCotizacionProgramaComponent.DIA_CORTE_MIN
      || n > ResumenCotizacionProgramaComponent.DIA_CORTE_MAX) {
      return null;
    }
    return n;
  }

  private calcularDiasProporcionalidad(): number {
    const corte = this.normalizarDiaCorte(this.corte);
    if (!this.fechaIngreso || corte == null) {
      return 0;
    }
    const diaIngreso = this.obtenerDiaDelMes(this.fechaIngreso);
    if (diaIngreso < 1) {
      return 0;
    }
    if (diaIngreso === corte) {
      return ResumenCotizacionProgramaComponent.DIAS_MES_COMPLETO_PROPORCIONALIDAD;
    }
    const fechaIngresoLocal = this.normalizarFechaLocal(this.fechaIngreso);
    const fechaCorteEfectiva = this.construirFechaCorteEfectiva(this.fechaIngreso, corte);
    const diasEntreFechas = this.diferenciaDiasCalendario(fechaIngresoLocal, fechaCorteEfectiva);
    return diasEntreFechas + 1;
  }

  get diasProporcionalidad(): number {
    return this.calcularDiasProporcionalidad();
  }

  onProporcionalidadChanged(value: 'SI' | 'NO'): void {
    this.proporcionalidad = value;
    if (value === 'NO') {
      this.corte = null;
    } else {
      this.cargarCorteDesdeAsociadoSiAplica();
    }
    this.recalcularPagoProporcionalEnTabla();
  }

  /**
   * Si proporcionalidad = SI y tipoPlan = A (asociado), consulta corte en consultarAsociado
   * y lo pinta en el campo Corte. Otros tipoPlan no llaman el servicio.
   */
  private cargarCorteDesdeAsociadoSiAplica(): void {
    const tipoPlan = (localStorage.getItem('tipoPlan') ?? '').toString().trim().toUpperCase();
    if (tipoPlan !== 'A') {
      return;
    }

    const { tipoDocumento, numeroDocumento } = this.getDocumentoActual();
    if (!tipoDocumento || !numeroDocumento) {
      return;
    }

    const request = ConsultarAsociadoService.buildRequest(tipoDocumento, numeroDocumento);
    this.consultarAsociadoService.consultarAsociado(request).subscribe({
      next: (resp) => {
        const item = resp?.status && Array.isArray(resp?.data?.jsonRespuesta)
          ? resp.data.jsonRespuesta[0]
          : null;
        const corteRaw = (item?.corte ?? '').toString().trim();
        if (!corteRaw) {
          return;
        }
        const corteNormalizado = this.normalizarDiaCorte(corteRaw);
        if (corteNormalizado == null) {
          return;
        }
        this.corte = corteNormalizado;
        this.recalcularPagoProporcionalEnTabla();
      },
      error: () => {
        // No bloquear el flujo de proporcionalidad si falla la consulta de asociado
      }
    });
  }

  onFechaIngresoChanged(value: Date | null): void {
    this.fechaIngreso = value;
    this.recalcularPagoProporcionalEnTabla();
  }

  onDiaCorteKeydown(event: KeyboardEvent): void {
    const teclasPermitidas = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter', 'Home', 'End'];
    if (teclasPermitidas.includes(event.key) || event.ctrlKey || event.metaKey) {
      return;
    }

    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }

  onDiaCortePaste(event: ClipboardEvent): void {
    const textoPegado = event.clipboardData?.getData('text') ?? '';
    if (!/^\d*$/.test(textoPegado)) {
      event.preventDefault();
    }
  }

  onDiaCorteChanged(value: unknown): void {
    this.corte = this.normalizarDiaCorte(value);
    this.recalcularPagoProporcionalEnTabla();
  }

  onProntoPagoMesesChanged(value: number): void {
    const mes = Number(value);
    this.prontoPagoMeses = Number.isFinite(mes) ? Math.min(Math.max(mes, 3), 12) : 12;
    this.recalcularProntoPagoEnTabla();
    this.emitirEstadoLiquidacion();
  }

  onMostrarTarifaAsociadoChanged(checked: boolean): void {
    this.mostrarTarifaAsociado = !!checked;
    if (!this.mostrarTarifaAsociado) {
      this.sourceRows = this.sourceRows.map((row) => ({
        ...row,
        precioBaseTarifaAsociado: 0
      }));
      this.dataSource.data = [...this.sourceRows];
      this.emitirEstadoLiquidacion();
      return;
    }
    this.cargarTarifaAsociadoEnTabla();
  }

  onCuotaInscripcionChanged(value: 'SI' | 'NO'): void {
    this.cuotaInscripcion = value;
    if (value !== 'SI') {
      this.limpiarCuotasInscripcionEnTabla();
      this.emitirEstadoLiquidacion();
      return;
    }
    this.recalcularCuotasInscripcionEnTabla();
  }

  get totalCuotaInscripcionTabla(): number {
    if (this.aplicacionCuotaPorBeneficiario) {
      return this.dataSource.data.reduce(
        (acc, row) => acc + Number(row.cuotaInscripcionValor || 0),
        0
      );
    }
    return Number(this.valorPagarCuotaInscripcion || 0);
  }

  get totalPrecioBaseMensual(): number {
    return this.sum('precioBaseMensual');
  }

  get totalPrecioBaseMensualAnexos(): number {
    return this.sum('precioBaseMensualAnexos');
  }

  get totalDescuentosCampana(): number {
    return this.sum('descuentosCampana');
  }

  get totalPagoProporcionalIngresoAnticipado(): number {
    return this.sum('pagoProporcionalIngresoAnticipado');
  }

  get totalDescuentoProntoPago(): number {
    const data = this.dataSource.data;
    if (!data.length) {
      return 0;
    }
    const total = data.reduce((acc, row) => acc + row.descuentoProntoPago, 0);
    return total / data.length;
  }

  get totalValorTotalPeriodoProntoPago(): number {
    return this.sum('valorTotalPeriodoProntoPago');
  }

  get totalPrecioBaseTarifaAsociado(): number {
    return this.sum('precioBaseTarifaAsociado');
  }

  get currentPage(): number {
    if (!this.paginator) {
      return 1;
    }
    return this.paginator.pageIndex + 1;
  }

  get totalPages(): number {
    if (!this.paginator) {
      return 1;
    }
    const size = this.paginator.pageSize || 1;
    const total = this.dataSource.data.length;
    return Math.max(Math.ceil(total / size), 1);
  }

  get pCuotaInscripcion(): string {
    return this.cuotaInscripcion === 'SI' &&
      Number(this.valorPagarCuotaInscripcion || 0) > 0
      ? '1'
      : '0';
  }

  get pPagoProporcionalAnticipado(): string {
    return this.proporcionalidad === 'SI' &&
      this.sourceRows.some(
        row =>
          Number(
            row.pagoProporcionalIngresoAnticipado || 0
          ) > 0
      )
      ? '1'
      : '0';
  }

  get pPrecioBaseAnexos(): string {
    return this.sourceRows.some(
      row => row.aplicaAnexos === true
    )
      ? '1'
      : '0';
  }

  get pTarifaAsociado(): string {
    return this.mostrarTarifaAsociado ? '1' : '0';
  }

  get mostrarPrecioBaseMensualAnexos(): boolean {
    return this.sourceRows.some(
      row => row.aplicaAnexos === true
    );
  }

  formatCurrency(value: number): string {
    return new Intl.NumberFormat('es-CO').format(value || 0);
  }

  abrirDetalleCotizacion(row: ResumenCotizacionRow): void {
    const idCotizacion = this.getIdCotizacionEnCurso();
    const dataBase: ModalDetalleCotizacionData = {
      idCotizacion,
      idCotizacionCampania: row.idCotizacionCampania ?? null,
      nombreBeneficiario: row.nombre,
      lineaNegocio: row.modalLineaNegocio || this.lineaNegocio,
      programa: row.modalPrograma || this.programaId,
      tarifaMensual: row.modalTarifaMensual || 0,
      descripcionTarifa: row.modalDescripcionTarifa || '',
      campaniaCodigo: row.modalCampaniaCodigo || '',
      campaniaNombre: row.modalCampaniaNombre || '',
      campaniaInicioVigencia: this.formatearFechaVigencia(row.modalCampaniaInicioVigencia),
      campaniaFinVigencia: this.formatearFechaVigencia(row.modalCampaniaFinVigencia),
      proporcionalidadValor: row.pagoProporcionalIngresoAnticipado,
      descuentoProntoPagoPorcentaje: row.descuentoProntoPago,
      cuotaInscripcionValor: 0,
      tarifaComoAsociadoValor: row.precioBaseTarifaAsociado,
      mesesProntoPago: this.prontoPagoMeses,
      ocultarLiquidacionProntoPago: this.columnaValorTabla !== 'periodoPronto',
      ocultarProporcionalidad: this.ocultarProporcionalidad
    };

    if (this.cuotaInscripcion !== 'SI') {
      this.abrirModalDetalle(dataBase);
      return;
    }

    if (this.aplicacionCuotaPorBeneficiario) {
      this.abrirModalDetalle({
        ...dataBase,
        cuotaInscripcionValor: Number(row.cuotaInscripcionValor || 0)
      });
      return;
    }

    if (Number(this.valorPagarCuotaInscripcion || 0) > 0) {
      this.abrirModalDetalle({
        ...dataBase,
        cuotaInscripcionValor: Number(this.valorPagarCuotaInscripcion || 0)
      });
      return;
    }

    const paramsCuota = this.obtenerParamsCuotaInscripcion(row);
    if (!paramsCuota) {
      this.abrirModalDetalle(dataBase);
      return;
    }

    const programa = (row.modalPrograma ?? '').toString().trim();
    this.resolverGrupoProgramaParaProntoPago(programa)
      .pipe(
        concatMap((grupoPrograma) =>
          this.consultarCotizacionService.consultarCuotaInscripcion({
            ...paramsCuota,
            grupoPrograma
          })
        ),
        map((resp) => {
          const valor = Number(resp?.data?.jsonRespuesta?.[0]?.VALOR_CUOTA ?? 0);
          return Number.isFinite(valor) && valor > 0 ? Math.round(valor) : 0;
        }),
        catchError(() => of(0))
      )
      .subscribe((cuota) => {
        this.abrirModalDetalle({
          ...dataBase,
          cuotaInscripcionValor: cuota
        });
      });
  }

  private abrirModalDetalle(data: ModalDetalleCotizacionData): void {
    this.dialog.open(ModalDetalleCotizacionComponent, {
      data,
      disableClose: true,
      autoFocus: false,
      width: '980px',
      maxWidth: '96vw',
      maxHeight: '90vh',
      panelClass: 'modal-detalle-cotizacion-panel'
    });
  }

  private obtenerParamsCuotaInscripcion(
    row: ResumenCotizacionRow
  ): { idTipoSolicitud: string; lineaNegocio: string; plan: string; edad: string; genero: string } | null {
    const idTipoSolicitud = (localStorage.getItem('tipoSolicitud') ?? '').toString().trim();
    const plan = (localStorage.getItem('tipoPlan') ?? '').toString().trim().toUpperCase();
    const lineaNegocio = this.toLineaNegocioCodigo(row.modalLineaNegocio || this.lineaNegocio);
    if (!idTipoSolicitud || !plan || !lineaNegocio) {
      return null;
    }
    const edadNum = Number(row.beneficiarioEdad ?? 0);
    const edad = Number.isFinite(edadNum) && edadNum > 0 ? String(Math.floor(edadNum)) : '';
    const genero = this.normalizarGenero(row.beneficiarioGenero);
    return { idTipoSolicitud, lineaNegocio, plan, edad, genero };
  }

  private limpiarCuotasInscripcionEnTabla(): void {
    this.aplicacionCuotaPorBeneficiario = false;
    this.valorPagarCuotaInscripcion = 0;
    this.sourceRows = this.sourceRows.map((row) => ({
      ...row,
      cuotaInscripcionValor: 0
    }));
    this.dataSource.data = [...this.sourceRows];
  }

  /**
   * Consulta getCuota por beneficiario (edad/género).
   * Si APLICACION_CUOTA = POR_BENEFICIARIO → valor por fila + total = suma.
   * En otro caso → filas con "-" (valor 0 en fila) + total = valor único.
   */
  private recalcularCuotasInscripcionEnTabla(): void {
    const solicitud = ++this._cuotaSolicitud;
    this.marcarCalculoPendiente('cuotaInscripcion', true);
    if (!this.sourceRows.length) {
      this.limpiarCuotasInscripcionEnTabla();
      this.emitirEstadoLiquidacion();
      this.marcarCalculoPendiente('cuotaInscripcion', false);
      return;
    }

    const calls = this.sourceRows.map((row) => {
      const paramsBase = this.obtenerParamsCuotaInscripcion(row);
      if (!paramsBase) {
        return of({ valor: 0, aplicacion: '' });
      }
      const programa = (row.modalPrograma ?? '').toString().trim();
      return this.resolverGrupoProgramaParaProntoPago(programa).pipe(
        concatMap((grupoPrograma) =>
          this.consultarCotizacionService.consultarCuotaInscripcion({
            ...paramsBase,
            grupoPrograma
          }).pipe(
            map((resp) => {
              const item = resp?.data?.jsonRespuesta?.[0];
              const valor = Number(item?.VALOR_CUOTA ?? 0);
              const aplicacion = (item?.APLICACION_CUOTA ?? '').toString().trim().toUpperCase();
              return {
                valor: Number.isFinite(valor) && valor > 0 ? Math.round(valor) : 0,
                aplicacion
              };
            }),
            catchError(() => of({ valor: 0, aplicacion: '' }))
          )
        )
      );
    });

    forkJoin(calls).pipe(
      finalize(() => {
        if (solicitud === this._cuotaSolicitud) {
          this.marcarCalculoPendiente('cuotaInscripcion', false);
        }
      })
    ).subscribe((resultados) => {
      const aplicacionDetectada = (resultados.find((r) => !!r.aplicacion)?.aplicacion ?? '').toUpperCase();
      const porBeneficiario = aplicacionDetectada === 'POR_BENEFICIARIO';
      this.aplicacionCuotaPorBeneficiario = porBeneficiario;

      if (porBeneficiario) {
        this.sourceRows = this.sourceRows.map((row, idx) => ({
          ...row,
          cuotaInscripcionValor: resultados[idx]?.valor ?? 0
        }));
        this.valorPagarCuotaInscripcion = this.sourceRows.reduce(
          (acc, row) => acc + Number(row.cuotaInscripcionValor || 0),
          0
        );
      } else {
        const valorUnico = resultados.find((r) => r.valor > 0)?.valor
          ?? resultados[0]?.valor
          ?? 0;
        this.sourceRows = this.sourceRows.map((row) => ({
          ...row,
          cuotaInscripcionValor: 0
        }));
        this.valorPagarCuotaInscripcion = valorUnico;
      }

      this.dataSource.data = [...this.sourceRows];
      this.emitirEstadoLiquidacion();
    });
  }

  private getIdCotizacionEnCurso(): number | null {
    const { tipoDocumento, numeroDocumento } = this.getDocumentoActual();
    const fromActual = this.getIdCotizacionActual(tipoDocumento, numeroDocumento);
    if (fromActual != null) {
      return fromActual;
    }

    const fromCreada = this.getIdCotizacionCreada(tipoDocumento, numeroDocumento);
    if (fromCreada != null) {
      return fromCreada;
    }

    const fromPrecargada = this.getIdCotizacionPrecargada(tipoDocumento, numeroDocumento);
    if (fromPrecargada != null) {
      return fromPrecargada;
    }

    const fromProgramas = this.getIdCotizacionFromProgramasContratante(tipoDocumento, numeroDocumento);
    if (fromProgramas != null) {
      return fromProgramas;
    }

    // cotizacion_cargada es exclusiva de edición; en venta nueva no debe resolver el id.
    if (this.esContextoEdicion()) {
      const fromCargada = this.getIdCotizacionFromKey(this.KEY_COTIZACION_CARGADA, tipoDocumento, numeroDocumento);
      if (fromCargada != null) {
        return fromCargada;
      }

      // Legacy plano sin documento: solo como último recurso en edición (colectivo usa otro componente).
      const legacy = Number(localStorage.getItem('idCotizacion'));
      if (Number.isFinite(legacy) && legacy > 0) {
        return legacy;
      }
    }

    return null;
  }

  /**
   * true solo en edición (Mis Cotizaciones o editMode en precargada).
   * cotizacion_cargada solo se escribe en ese contexto; fuera de él no debe usarse.
   */
  private esContextoEdicion(): boolean {
    try {
      if (localStorage.getItem('cotizacion_edicion_contratante')) {
        return true;
      }
      const rawPrec = localStorage.getItem(this.KEY_COTIZACION_PRECARGADA);
      if (rawPrec) {
        const prec = JSON.parse(rawPrec);
        if (prec?.editMode === true) {
          return true;
        }
      }
    } catch { /* no-op */ }
    return false;
  }

  /**
   * Retoma incompleta (precargada sin editMode). En edición la resuelve esContextoEdicion + cargada/override.
   */
  private getIdCotizacionPrecargada(tipoDocumento: string, numeroDocumento: string): number | null {
    try {
      const raw = localStorage.getItem(this.KEY_COTIZACION_PRECARGADA);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (parsed?.editMode === true) {
        return null;
      }
    } catch { /* no-op */ }
    return this.getIdCotizacionFromKey(this.KEY_COTIZACION_PRECARGADA, tipoDocumento, numeroDocumento);
  }

  private getDocumentoActual(): { tipoDocumento: string; numeroDocumento: string } {
    let tipoDocumento = '';
    let numeroDocumento = '';
    try {
      const raw = localStorage.getItem(this.KEY_DATOS_CONTRATANTE);
      if (raw) {
        const parsed = JSON.parse(raw);
        tipoDocumento = (parsed?.tipoDocumento ?? '').toString().trim();
        numeroDocumento = (parsed?.numeroDocumento ?? '').toString().trim();
      }
    } catch {
      tipoDocumento = '';
      numeroDocumento = '';
    }

    const autoritativo = this.getDocumentoContratanteAutoritativo();
    if (autoritativo.tipoDocumento && autoritativo.numeroDocumento) {
      const hayDatosForm = !!tipoDocumento && !!numeroDocumento;
      const mismatch =
        hayDatosForm &&
        (tipoDocumento !== autoritativo.tipoDocumento ||
          numeroDocumento !== autoritativo.numeroDocumento);
      if (!hayDatosForm || mismatch) {
        return autoritativo;
      }
    }

    return { tipoDocumento, numeroDocumento };
  }

  private getDocumentoContratanteAutoritativo(): { tipoDocumento: string; numeroDocumento: string } {
    try {
      const rawCreada = localStorage.getItem(this.KEY_COTIZACION_CREADA);
      if (rawCreada) {
        const creada = JSON.parse(rawCreada);
        const tipoDocumento = (creada?.tipoDocumento ?? '').toString().trim();
        const numeroDocumento = (creada?.numeroDocumento ?? '').toString().trim();
        const id = Number(creada?.idCotizacion ?? creada?.data?.idCotizacion);
        if (tipoDocumento && numeroDocumento && Number.isFinite(id) && id > 0) {
          return { tipoDocumento, numeroDocumento };
        }
      }
    } catch {
      // no-op
    }

    try {
      const raw = localStorage.getItem(this.KEY_PROGRAMAS_CONTRATANTE);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
          const tipoDocumento = (parsed?.tipoDocumento ?? '').toString().trim();
          const numeroDocumento = (parsed?.numeroDocumento ?? '').toString().trim();
          const id = Number(parsed?.idCotizacion);
          if (tipoDocumento && numeroDocumento && Number.isFinite(id) && id > 0) {
            return { tipoDocumento, numeroDocumento };
          }
        }
      }
    } catch {
      // no-op
    }

    return { tipoDocumento: '', numeroDocumento: '' };
  }

  private getIdCotizacionFromProgramasContratante(
    tipoDocumento: string,
    numeroDocumento: string,
  ): number | null {
    try {
      const raw = localStorage.getItem(this.KEY_PROGRAMAS_CONTRATANTE);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
        return null;
      }
      const tipo = (parsed?.tipoDocumento ?? '').toString().trim();
      const num = (parsed?.numeroDocumento ?? '').toString().trim();
      const docCoincide = !!tipo && !!num && tipo === tipoDocumento && num === numeroDocumento;
      if (!docCoincide) return null;
      const id = Number(parsed?.idCotizacion);
      return Number.isFinite(id) && id > 0 ? id : null;
    } catch {
      return null;
    }
  }

  private getIdCotizacionActual(tipoDocumento: string, numeroDocumento: string): number | null {
    try {
      const raw = localStorage.getItem(this.KEY_COTIZACION_ACTUAL);
      if (!raw) return null;
      const actual: CotizacionContratanteActual = JSON.parse(raw);
      const tipo = (actual?.tipoDocumento ?? '').toString().trim();
      const num = (actual?.numeroDocumento ?? '').toString().trim();
      const docCoincide = !!tipo && !!num && tipo === tipoDocumento && num === numeroDocumento;
      if (!docCoincide) return null;
      const id = Number(actual?.idCotizacion);
      return Number.isFinite(id) && id > 0 ? id : null;
    } catch {
      return null;
    }
  }

  private getIdCotizacionCreada(tipoDocumento: string, numeroDocumento: string): number | null {
    try {
      const raw = localStorage.getItem(this.KEY_COTIZACION_CREADA);
      if (!raw) return null;
      const created = JSON.parse(raw);
      const tipo = (created?.tipoDocumento ?? '').toString().trim();
      const num = (created?.numeroDocumento ?? '').toString().trim();
      const docCoincide = !!tipo && !!num && tipo === tipoDocumento && num === numeroDocumento;
      if (!docCoincide) return null;
      const id = Number(created?.idCotizacion ?? created?.data?.idCotizacion);
      return Number.isFinite(id) && id > 0 ? id : null;
    } catch {
      return null;
    }
  }

  /**
   * Lee idCotizacion de una key de localStorage.
   * Si se proveen tipoDocumento/numeroDocumento Y la key almacena documento,
   * exige que coincidan (evita tomar un id de otra cotización/contratante,
   * p. ej. cotizacion_precargada residual con id viejo). Si la key no guarda
   * documento (ej. cotizacion_cargada), no se puede validar y se usa el id tal cual.
   */
  private getIdCotizacionFromKey(
    key: string,
    tipoDocumento?: string,
    numeroDocumento?: string
  ): number | null {
    try {
      const raw = localStorage.getItem(key);
      if (!raw) return null;
      const parsed = JSON.parse(raw);

      const tipoKey = (parsed?.tipoDocumento ?? '').toString().trim();
      const numKey = (parsed?.numeroDocumento ?? '').toString().trim();
      const debeValidarDoc =
        !!tipoDocumento && !!numeroDocumento && (!!tipoKey || !!numKey);
      if (debeValidarDoc) {
        const docCoincide = tipoKey === tipoDocumento && numKey === numeroDocumento;
        if (!docCoincide) return null;
      }

      const id = Number(parsed?.idCotizacion ?? parsed?.data?.idCotizacion);
      return Number.isFinite(id) && id > 0 ? id : null;
    } catch {
      return null;
    }
  }

  private restablecerTabla(): void {
    this.dataSource.data = [...this.sourceRows];
    this.paginator?.firstPage();
  }

  /** Clave estable para comparar identidad de una fila entre renders. */
  private keyFila(row: ResumenCotizacionRow): string {
    return `${row.idBenPrograma ?? ''}|${row.nombre}|${row.modalPrograma}|${row.precioBaseMensual}`;
  }

  /**
   * Devuelve true si prev y curr tienen las mismas filas (mismo beneficiario + programa + tarifa base).
   * Diferencias en descuentosCampana/precioBaseMensualAnexos no cuentan como cambio de identidad.
   */
  private mismaIdentidadDeFilas(prev: ResumenCotizacionRow[], next: ResumenCotizacionRow[]): boolean {
    if (!Array.isArray(prev) || !Array.isArray(next) || prev.length !== next.length) return false;
    return prev.every((row, i) => {
      const n = next[i];
      return row.idBenPrograma === n.idBenPrograma
        && row.nombre === n.nombre
        && row.precioBaseMensual === n.precioBaseMensual
        && row.modalPrograma === n.modalPrograma
        && row.modalLineaNegocio === n.modalLineaNegocio;
    });
  }

  /**
   * Aplica el estado inicial guardado (edición desde Mis Cotizaciones).
   * Solo se invoca cuando estadoInicial está definido; no afecta el flujo de creación.
   */
  private aplicarEstadoInicialInterno(): void {
    const s = this.estadoInicial;
    if (!s) return;
    this.proporcionalidad = s.proporcionalidad;
    this.cuotaInscripcion = s.aplicaCuotaInscripcion;
    this.valorPagarCuotaInscripcion = s.valorCuotaInscripcion ?? 0;
    const m = Number(s.mesesProntoPago ?? 0);

    this.prontoPagoMeses =
      Number.isFinite(m) && m >= 3 && m <= 12
        ? m
        : 0;
    // const m = Number(s.mesesProntoPago);
    // this.prontoPagoMeses = (Number.isFinite(m) && m >= 3 && m <= 12) ? m : 12;
    this.mostrarTarifaAsociado = s.aplicaTarifaAsociado;
    // new Date("2026-03-07") → interpreta como UTC midnight → en UTC-5 muestra el día anterior (06/03).
    // Agregar T00:00:00 (sin Z) fuerza interpretación en hora local del navegador.
    this.fechaIngreso = s.fechaIngreso
      ? new Date(s.fechaIngreso.includes('T') ? s.fechaIngreso : `${s.fechaIngreso}T00:00:00`)
      : null;
    this.corte = s.diaCorte ?? null;
    // this.recalcularPagoProporcionalEnTabla();
    // this.recalcularProntoPagoEnTabla();
    // if (this.mostrarTarifaAsociado) {
    //   this.cargarTarifaAsociadoEnTabla();
    // }
    // if (this.cuotaInscripcion === 'SI') {
    //   this.recalcularCuotasInscripcionEnTabla();
    // } else {
    //   this.limpiarCuotasInscripcionEnTabla();
    //   this.emitirEstadoLiquidacion();
    // }
    // Si alguna fila quedó sin proporcional, lo completa.
    this.completarPagoProporcionalFaltanteEnEdicion();
    // El beneficiario que se acaba de agregar no tiene liquidación guardada:
    // el pronto pago de los demás se deja como está y solo se calcula el que falta.
    this.completarProntoPagoFaltanteEnEdicion();
    // Si asociado está en sí y quedó en 0, consulta de nuevo.
    if (
      this.mostrarTarifaAsociado &&
      this.sourceRows.some((row) => !(Number(row.precioBaseTarifaAsociado) > 0))
    ) {
      this.cargarTarifaAsociadoEnTabla();
    }
    this.dataSource.data = [...this.sourceRows];
    this.emitirEstadoLiquidacion();
    this.estadoPersistidoAplicado = true;
  }

  /** Completa el proporcional en 0 cuando ya hay tarifa y aplica proporcionalidad. */
  private completarPagoProporcionalFaltanteEnEdicion(): void {
    if (this.ocultarProporcionalidad || this.proporcionalidad !== 'SI') {
      return;
    }
    const dias = this.diasProporcionalidad;
    if (!(dias > 0) || !this.sourceRows.length) {
      return;
    }

    let huboCambio = false;
    this.sourceRows = this.sourceRows.map((row) => {
      const tarifaMensual = Number(row.precioBaseMensual || 0);
      const actual = Number(row.pagoProporcionalIngresoAnticipado || 0);
      if (tarifaMensual <= 0 || actual > 0) {
        return row;
      }
      huboCambio = true;
      return {
        ...row,
        pagoProporcionalIngresoAnticipado: Math.round((tarifaMensual / 30) * dias),
      };
    });

    if (huboCambio) {
      this.dataSource.data = [...this.sourceRows];
    }
  }

  /** Una fila con tarifa y pronto pago en cero todavía no se ha liquidado. */
  private filaSinProntoPago(row: ResumenCotizacionRow): boolean {
    const tarifa = Number(row.precioBaseMensual || 0);
    if (!(tarifa > 0)) {
      return false;
    }
    const porcentaje = Number(row.descuentoProntoPago || 0);
    const total = Number(row.valorTotalPeriodoProntoPago || 0);
    return porcentaje === 0 && total === 0;
  }

  /** Calcula el pronto pago de quien se agregó en la edición, sin pisar el de los demás. */
  private completarProntoPagoFaltanteEnEdicion(): void {
    if (this.columnaValorTabla === 'ninguna') {
      return;
    }
    if (!this.sourceRows.some((row) => this.filaSinProntoPago(row))) {
      return;
    }
    this._soloProntoPagoFaltante = true;
    this.recalcularProntoPagoEnTabla();
  }

  private aplicarRows(): void {
    const rows = Array.isArray(this.rowsData)
      ? [...this.rowsData]
      : [];

    const esCargaInicialEdicion =
      !!this.estadoInicial &&
      !this.estadoPersistidoAplicado;

    this.sourceRows = rows.map((row) => ({
      ...row,

      precioBaseTarifaAsociado:
        esCargaInicialEdicion
          ? Number(row.precioBaseTarifaAsociado ?? 0)
          : this.mostrarTarifaAsociado
            ? Number(row.precioBaseTarifaAsociado ?? 0)
            : 0,

      cuotaInscripcionValor:
        Number(row.cuotaInscripcionValor ?? 0),
    }));

    this.dataSource.data = [...this.sourceRows];
    this.paginator?.firstPage();

    // Solamente la primera carga de edición conserva los datos.
    if (esCargaInicialEdicion) {
      this.emitirEstadoLiquidacion();
      return;
    }

    // Si las filas cambian después de cargar, sí recalcular.
    this.recalcularPagoProporcionalEnTabla();
    this.recalcularProntoPagoEnTabla();

    if (this.mostrarTarifaAsociado) {
      this.cargarTarifaAsociadoEnTabla();
    }

    if (this.cuotaInscripcion === 'SI') {
      this.recalcularCuotasInscripcionEnTabla();
    } else {
      this.emitirEstadoLiquidacion();
    }
  }

  private recalcularPagoProporcionalEnTabla(): void {
    const mostrarYCalcular = !this.ocultarProporcionalidad && this.proporcionalidad === 'SI';
    const dias = this.diasProporcionalidad;
    this.sourceRows = this.sourceRows.map((row) => {
      const tarifaMensual = Number(row.precioBaseMensual || 0);
      const valorProporcional = mostrarYCalcular && dias > 0
        ? Math.round((tarifaMensual / 30) * dias)
        : 0;
      return { ...row, pagoProporcionalIngresoAnticipado: valorProporcional };
    });
    this.dataSource.data = [...this.sourceRows];
    this.emitirEstadoLiquidacion();
  }

  /** Encola el recálculo para el próximo tick. Múltiples llamadas síncronas se colapsan en una. */
  private recalcularProntoPagoEnTabla(): void {
    if (!this.sourceRows.length) {
      // No hay filas que consultar (por ejemplo, un programa recién eliminado).
      // Invalida cualquier solicitud anterior para que no deje el loader bloqueado.
      this._prontoPagoSolicitud += 1;
      this.marcarCalculoPendiente('prontoPago', false);
      return;
    }
    this.marcarCalculoPendiente('prontoPago', true);
    this._prontoPagoSubject.next();
  }

  private _ejecutarRecalcularProntoPago(): void {
    const solicitud = ++this._prontoPagoSolicitud;
    const soloFaltantes = this._soloProntoPagoFaltante;
    this._soloProntoPagoFaltante = false;
    if (!this.sourceRows.length) {
      this.dataSource.data = [];
      this.marcarCalculoPendiente('prontoPago', false);
      return;
    }

    if (this.columnaValorTabla === 'ninguna') {
      if (soloFaltantes) {
        this.marcarCalculoPendiente('prontoPago', false);
        return;
      }
      this.sourceRows = this.sourceRows.map((row) => ({ ...row, descuentoProntoPago: 0, valorTotalPeriodoProntoPago: 0 }));
      this.dataSource.data = [...this.sourceRows];
      this.emitirEstadoLiquidacion();
      this.marcarCalculoPendiente('prontoPago', false);
      return;
    }

    const tipoSolicitud = (localStorage.getItem('tipoSolicitud') ?? '').toString().trim() || '1';
    const tipoPlan = (localStorage.getItem('tipoPlan') ?? '').toString().trim().toUpperCase() || 'F';
    const cantidadMeses = this.prontoPagoMeses || 12;

    const uniqueCampaniaIds = [
      ...new Set(
        this.sourceRows
          .map((r) => r.idCotizacionCampania)
          .filter((id): id is number => id != null && id > 0)
      )
    ];

    const cargarDetalles$ = uniqueCampaniaIds.length === 0
      ? of(new Map<number, CampaniaDetalleItem[]>())
      : forkJoin(
        uniqueCampaniaIds.map((id) => this.consultarCotizacionService.consultarCampaniaDetalle(id).pipe(
          catchError((err: any) => of({ status: false, data: null } as ConsultarCampaniaDetalleHttpResponse))
        ))
      ).pipe(
        map((responses) => {
          const mapa = new Map<number, CampaniaDetalleItem[]>();
          uniqueCampaniaIds.forEach((id, idx) => {
            const r = responses[idx];
            if (r?.status && r.data?.detalles?.length) {
              mapa.set(id, r.data.detalles);
            }
          });
          return mapa;
        })
      );

    cargarDetalles$.pipe(
      finalize(() => {
        if (solicitud === this._prontoPagoSolicitud && this.columnaValorTabla === 'totalSimple') {
          this.marcarCalculoPendiente('prontoPago', false);
        }
      })
    ).subscribe((detallePorCampania: any) => {
      if (this.columnaValorTabla === 'totalSimple') {
        this.sourceRows = this.sourceRows.map((row) => {
          if (soloFaltantes && !this.filaSinProntoPago(row)) {
            return row;
          }
          const programa = (row.modalPrograma ?? '').toString().trim();
          const lineaCodigo = this.toLineaNegocioCodigo(row.modalLineaNegocio || this.lineaNegocio);
          const tarifaMensual = Number(row.precioBaseMensual || 0);

          if (!programa || !lineaCodigo || tarifaMensual <= 0) {
            return { ...row, descuentoProntoPago: 0, valorTotalPeriodoProntoPago: 0 };
          }

          const idCc = row.idCotizacionCampania;
          const detalles = idCc != null && idCc > 0 ? detallePorCampania.get(idCc) ?? [] : [];
          const v = Math.round(this.subtotalPeriodoConDescuentosCampaña(tarifaMensual, 1, detalles));
          return { ...row, descuentoProntoPago: 0, valorTotalPeriodoProntoPago: Math.max(v, 0) };
        });
        this.dataSource.data = [...this.sourceRows];
        this.emitirEstadoLiquidacion();
        return;
      }

      const calls = this.sourceRows.map((row) => {
        if (soloFaltantes && !this.filaSinProntoPago(row)) {
          return of({
            descuentoProntoPago: Number(row.descuentoProntoPago || 0),
            valorTotalPeriodoProntoPago: Number(row.valorTotalPeriodoProntoPago || 0)
          });
        }
        const programa = (row.modalPrograma ?? '').toString().trim();
        const lineaCodigo = this.toLineaNegocioCodigo(row.modalLineaNegocio || this.lineaNegocio);
        const tarifaMensual = Number(row.precioBaseMensual || 0);

        if (!programa || !lineaCodigo || tarifaMensual <= 0) {
          return of({ descuentoProntoPago: 0, valorTotalPeriodoProntoPago: 0 });
        }

        const idCc = row.idCotizacionCampania;
        const detalles = idCc != null && idCc > 0 ? detallePorCampania.get(idCc) ?? [] : [];
        const baseTrasCampaña = this.subtotalPeriodoConDescuentosCampaña(tarifaMensual, cantidadMeses, detalles);

        const aliasMap: Record<string, string> = { "1": "MI", "2": "SAO", "3": "CEM" };
        const lineaAlfa = aliasMap[lineaCodigo] || "MI";

        const planComercial = ['C', 'GA', 'AG'].includes(tipoPlan) ? 'C' : (tipoPlan === 'A' ? 'A' : 'F');

        return this.resolverGrupoProgramaParaProntoPago(programa).pipe(
          concatMap((grupoPrograma) =>
            this.consultarCotizacionService
              .consultarPorcentajeDescuentoSp({
                lineaNegocio: lineaAlfa,
                meses: cantidadMeses,
                plan: planComercial,
                grupoPrograma,
                sucursal: ''
              })
              .pipe(
                map((resp: any) => {
                  const lista = resp?.jsonRespuesta || resp?.data?.jsonRespuesta || resp?.data || [];
                  const item = Array.isArray(lista) ? lista[0] : {};

                  const descuentoRaw = item?.DESCUENTO ?? item?.descuento ?? '0';
                  const porcentaje = parseFloat(descuentoRaw.toString().replace('%', '').trim());
                  const porcentajeSeguro = Number.isFinite(porcentaje) ? Math.max(Math.min(porcentaje, 100), 0) : 0;

                  const valorConProntoPago = Math.round(baseTrasCampaña * (1 - porcentajeSeguro / 100));
                  return {
                    descuentoProntoPago: porcentajeSeguro,
                    valorTotalPeriodoProntoPago: Math.max(valorConProntoPago, 0)
                  };
                }),
                catchError((err: any) => {
                  console.error('[ProntoPagoSp] Fallo controlado en la fila:', err);
                  return of({ descuentoProntoPago: 0, valorTotalPeriodoProntoPago: Math.max(Math.round(baseTrasCampaña), 0) });
                })
              )
          )
        );
      });

      forkJoin(calls).pipe(
        finalize(() => {
          if (solicitud === this._prontoPagoSolicitud && this.columnaValorTabla !== 'totalSimple') {
            this.marcarCalculoPendiente('prontoPago', false);
          }
        })
      ).subscribe((valores: any[]) => {
        this.sourceRows = this.sourceRows.map((row, idx) => ({
          ...row,
          descuentoProntoPago: valores[idx]?.descuentoProntoPago ?? 0,
          valorTotalPeriodoProntoPago: valores[idx]?.valorTotalPeriodoProntoPago ?? 0
        }));
        this.dataSource.data = [...this.sourceRows];
        this.emitirEstadoLiquidacion();
      });
    });
  }
  /* private recalcularProntoPagoEnTabla(): void {
     if (!this.sourceRows.length) {
       this.dataSource.data = [];
       return;
     }
 
     if (this.columnaValorTabla === 'ninguna') {
       this.sourceRows = this.sourceRows.map((row) => ({
         ...row,
         descuentoProntoPago: 0,
         valorTotalPeriodoProntoPago: 0
       }));
       this.dataSource.data = [...this.sourceRows];
       this.emitirEstadoLiquidacion();
       return;
     }
 
     const tipoSolicitud = (localStorage.getItem('tipoSolicitud') ?? '').toString().trim() || '1';
     const tipoPlan = (localStorage.getItem('tipoPlan') ?? '').toString().trim().toUpperCase() || 'F';
     const cantidadMeses = this.prontoPagoMeses || 12;
 
     const uniqueCampaniaIds = [
       ...new Set(
         this.sourceRows
           .map((r) => r.idCotizacionCampania)
           .filter((id): id is number => id != null && id > 0)
       )
     ];
 
     const cargarDetalles$ =
       uniqueCampaniaIds.length === 0
         ? of(new Map<number, CampaniaDetalleItem[]>())
         : forkJoin(
             uniqueCampaniaIds.map((id) =>
               this.consultarCotizacionService.consultarCampaniaDetalle(id).pipe(
                 catchError(
                   () =>
                     of({
                       status: false,
                       data: null
                     } as ConsultarCampaniaDetalleHttpResponse)
                 )
               )
             )
           ).pipe(
             map((responses) => {
               const mapa = new Map<number, CampaniaDetalleItem[]>();
               uniqueCampaniaIds.forEach((id, idx) => {
                 const r = responses[idx];
                 if (r?.status && r.data?.detalles?.length) {
                   mapa.set(id, r.data.detalles);
                 }
               });
               return mapa;
             })
           );
 
     cargarDetalles$.subscribe((detallePorCampania) => {
       if (this.columnaValorTabla === 'totalSimple') {
         this.sourceRows = this.sourceRows.map((row) => {
           const programa = (row.modalPrograma ?? '').toString().trim();
           const lineaCodigo = this.toLineaNegocioCodigo(row.modalLineaNegocio || this.lineaNegocio);
           const tarifaMensual = Number(row.precioBaseMensual || 0);
           if (!programa || !lineaCodigo || tarifaMensual <= 0) {
             return { ...row, descuentoProntoPago: 0, valorTotalPeriodoProntoPago: 0 };
           }
           const idCc = row.idCotizacionCampania;
           const detalles =
             idCc != null && idCc > 0 ? detallePorCampania.get(idCc) ?? [] : [];
           const v = Math.round(
             this.subtotalPeriodoConDescuentosCampaña(tarifaMensual, 1, detalles)
           );
           return {
             ...row,
             descuentoProntoPago: 0,
             valorTotalPeriodoProntoPago: Math.max(v, 0)
           };
         });
         this.dataSource.data = [...this.sourceRows];
         this.emitirEstadoLiquidacion();
         return;
       }
 
       const calls = this.sourceRows.map((row) => {
         const programa = (row.modalPrograma ?? '').toString().trim();
         const lineaCodigo = this.toLineaNegocioCodigo(row.modalLineaNegocio || this.lineaNegocio);
         const tarifaMensual = Number(row.precioBaseMensual || 0);
 
         if (!programa || !lineaCodigo || tarifaMensual <= 0) {
           return of({ descuentoProntoPago: 0, valorTotalPeriodoProntoPago: 0 });
         }
 
         const idCc = row.idCotizacionCampania;
         const detalles =
           idCc != null && idCc > 0 ? detallePorCampania.get(idCc) ?? [] : [];
         const baseTrasCampaña = this.subtotalPeriodoConDescuentosCampaña(
           tarifaMensual,
           cantidadMeses,
           detalles
         );
 
         return this.consultarCotizacionService
           .consultarDescuentosProntoPago({
             tipoSolicitud,
             tipoPlan,
             lineaNegocio: lineaCodigo,
             programa,
             cantidadMeses
           })
           .pipe(
             map((resp) => {
               const descuentoRaw = resp?.data?.jsonRespuesta?.[0]?.descuento ?? '0';
               const porcentaje = Number(descuentoRaw);
               const porcentajeSeguro = Number.isFinite(porcentaje)
                 ? Math.max(Math.min(porcentaje, 100), 0)
                 : 0;
               const valorConProntoPago = Math.round(
                 baseTrasCampaña * (1 - porcentajeSeguro / 100)
               );
               return {
                 descuentoProntoPago: porcentajeSeguro,
                 valorTotalPeriodoProntoPago: Math.max(valorConProntoPago, 0)
               };
             }),
             catchError(() => of({ descuentoProntoPago: 0, valorTotalPeriodoProntoPago: 0 }))
           );
       });
 
       forkJoin(calls).subscribe((valores) => {
         this.sourceRows = this.sourceRows.map((row, idx) => ({
           ...row,
           descuentoProntoPago: valores[idx]?.descuentoProntoPago ?? 0,
           valorTotalPeriodoProntoPago: valores[idx]?.valorTotalPeriodoProntoPago ?? 0
         }));
         this.dataSource.data = [...this.sourceRows];
         this.emitirEstadoLiquidacion();
       });
     });
 
   } */

  /**
   * Resuelve el código de grupo_programa vía getGrupoProgramaxPrograma.
   * Extrae la parte antes de "|" (ej. "ORPR | ORO PRIME..." → "ORPR").
   * Cachea por programa para no repetir HTTP en filas del mismo programa.
   * Usado por pronto pago (P_GRUPO_PROGRAMA) y por getCuota.
   */
  private resolverGrupoProgramaParaProntoPago(programa: string) {
    const key = (programa ?? '').toString().trim().toUpperCase();
    if (!key) {
      return of('');
    }

    const cached = ResumenCotizacionProgramaComponent.grupoProgramaXProgramaCache.get(key);
    if (cached !== undefined) {
      return of(cached);
    }

    return this.consultarCotizacionService.consultarGrupoProgramaXPrograma({ programa: key }).pipe(
      map((resp) => {
        const lista = resp?.data?.jsonRespuesta ?? [];
        const item = Array.isArray(lista) && lista.length > 0 ? lista[0] : null;
        const raw = (item?.grupo_programa ?? '').toString().trim();
        const codigo = raw.includes('|')
          ? raw.split('|')[0].trim().toUpperCase()
          : raw.toUpperCase();
        ResumenCotizacionProgramaComponent.grupoProgramaXProgramaCache.set(key, codigo);
        return codigo;
      }),
      catchError((err) => {
        console.warn('[ProntoPago] No se pudo resolver grupo_programa para', key, err);
        return of('');
      })
    );
  }

  /**
   * Suma mes 1..N: tarifa × (1 − % campaña por mes). N = meses de pronto pago (ej. 3 → meses 1, 2 y 3).
   */
  private subtotalPeriodoConDescuentosCampaña(
    tarifaMensual: number,
    cantidadMeses: number,
    detalles: CampaniaDetalleItem[]
  ): number {
    const n = Math.max(Math.floor(cantidadMeses) || 1, 1);
    const mapaPct = new Map<number, number>();
    (detalles ?? []).forEach((d) => {
      const cuota = d.numeroCuota;
      const p = Number(d.porcentajeDescuento ?? 0);
      if (cuota != null && Number.isFinite(cuota) && cuota > 0 && Number.isFinite(p)) {
        mapaPct.set(Math.floor(cuota), p);
      }
    });
    let suma = 0;
    for (let mes = 1; mes <= n; mes++) {
      const pct = Math.min(Math.max(mapaPct.get(mes) ?? 0, 0), 100);
      suma += tarifaMensual * (1 - pct / 100);
    }
    return suma;
  }

  private toLineaNegocioCodigo(linea: string): string {
    const value = (linea ?? '').toString().trim().toUpperCase();
    if (value === 'MI') return '1';
    if (value === 'SAO' || value === 'SO') return '2';
    if (value === 'CEM') return '3';
    return '';
  }

  /** MI / SAO / CEM para el servicio de homologo asociado (acepta codigo numerico o alfa). */
  private toLineaNegocioAlfa(linea: string): string {
    const codigo = this.toLineaNegocioCodigo(linea);
    if (codigo === '1') return 'MI';
    if (codigo === '2') return 'SAO';
    if (codigo === '3') return 'CEM';
    const value = (linea ?? '').toString().trim().toUpperCase();
    if (value === 'SO') return 'SAO';
    if (value === 'MI' || value === 'SAO' || value === 'CEM') return value;
    return '';
  }

  /**
   * Resuelve el codigo de programa a usar al consultar tarifas con plan A.
   * Ej.: OPLF (familiar) -> OPLA via COTIZADOR_CARNET_PROGRAMA.PROGRAMA_HOMOLOGO_ASOCIADO.
   */
  private resolverProgramaConsultaTarifaAsociado(programa: string, lineaRaw: string) {
    const programaNorm = programa.trim().toUpperCase();
    const tipoPlanVenta = (localStorage.getItem('tipoPlan') ?? '').toString().trim().toUpperCase();
    if (tipoPlanVenta === 'A') {
      return of(programaNorm);
    }

    const lineaAlfa = this.toLineaNegocioAlfa(lineaRaw);
    if (!lineaAlfa) {
      return of(programaNorm);
    }

    const cacheKey = `${lineaAlfa}|${programaNorm}`;
    const cached = ResumenCotizacionProgramaComponent.programaHomologoAsociadoCache.get(cacheKey);
    if (cached) {
      return of(cached);
    }

    return this.consultarLineasGruposProgramasService
      .consultarProgramaHomologoAsociado({ programa: programaNorm, lineaNegocio: lineaAlfa })
      .pipe(
        map((resp) => {
          const homologo = (resp?.data?.programaHomologoAsociado ?? '').toString().trim().toUpperCase();
          const programaConsulta = homologo || programaNorm;
          ResumenCotizacionProgramaComponent.programaHomologoAsociadoCache.set(cacheKey, programaConsulta);
          return programaConsulta;
        }),
        catchError(() => of(programaNorm))
      );
  }

  private cargarTarifaAsociadoEnTabla(): void {
    const solicitud = ++this._tarifaSolicitud;
    this.marcarCalculoPendiente('tarifaAsociado', true);
    if (!this.sourceRows.length) {
      this.dataSource.data = [];
      this.emitirEstadoLiquidacion();
      this.marcarCalculoPendiente('tarifaAsociado', false);
      return;
    }

    const calls = this.sourceRows.map((row) => this.consultarValorTarifaAsociadoFila(row));

    forkJoin(calls).pipe(
      finalize(() => {
        if (solicitud === this._tarifaSolicitud) {
          this.marcarCalculoPendiente('tarifaAsociado', false);
        }
      })
    ).subscribe((valores) => {
      this.sourceRows = this.sourceRows.map((row, idx) => ({
        ...row,
        precioBaseTarifaAsociado: valores[idx] ?? 0
      }));
      this.dataSource.data = [...this.sourceRows];
      this.emitirEstadoLiquidacion();
    });
  }

  private marcarCalculoPendiente(operacion: string, pendiente: boolean): void {
    const clave = `${this.programaId}|${operacion}`;
    if (pendiente) {
      if (this.operacionesPendientes.has(clave)) return;
      this.operacionesPendientes.add(clave);
    } else {
      if (!this.operacionesPendientes.has(clave)) return;
      this.operacionesPendientes.delete(clave);
    }
    this.calculoPendienteChange.emit({
      programaId: this.programaId,
      operacion,
      pendiente,
      revision: this.cargaRevision
    });
  }

  private consultarValorTarifaAsociadoFila(row: ResumenCotizacionRow) {
    const lineaRaw = row.modalLineaNegocio || this.lineaNegocio;
    const lineaNegocio = this.toLineaNegocioCodigo(lineaRaw);
    const programaGuardado = (row.modalPrograma ?? '').toString().trim();
    const tipoPlanFiltro = this.obtenerTipoPlanFiltroTarifaAsociado();
    if (!lineaNegocio || !programaGuardado) {
      return of(0);
    }

    return this.resolverProgramaConsultaTarifaAsociado(programaGuardado, lineaRaw).pipe(
      concatMap((programaConsulta) =>
        this.consultarTarifasIndividualesService
          .consultarTarifasIndividualesLegacy({
            pnu_pagina: '1',
            pnu_tamanoPagina: '1000',
            lineaNegocio,
            plan: tipoPlanFiltro,
            grupoPrograma: '',
            programa: programaConsulta,
            planTarifario: '',
            pvc_campoOrden: ''
          })
          .pipe(
            concatMap((legacyResp) => {
              const tarifaSeleccionada = this.extraerCodigoTarifaDesdeFila(row);
              const lookup = this.resolverLookupTarifaAsociadoLegacy(
                legacyResp,
                programaConsulta,
                tipoPlanFiltro,
                tarifaSeleccionada
              );
              if (!lookup) {
                return of(0);
              }

              const edad = Number(row.beneficiarioEdad ?? 0);
              const sexo = this.normalizarGenero(row.beneficiarioGenero);
              const parentesco = (row.beneficiarioParentesco ?? 'T').trim() || 'T';
              const edadParam = Number.isFinite(edad) && edad >= 0 ? String(edad) : '';
              const inteTipo = lookup.tariTipo === 'C' ? 'C' : 'I';

              return this.consultarTarifasIndividualesService
                .consultarTarifasIndividualesValores({
                  prm_cuenta: '1',
                  prm_plan_codi: lookup.prmPlanCodi,
                  prm_tari: lookup.prmTari,
                  prm_subcta: lookup.prmSubcta || undefined,
                  prm_paren: parentesco,
                  prm_edad: edadParam,
                  prm_sexo: sexo,
                  prm_inte_tipo: inteTipo,
                  // I → 1; C → vacío.
                  cant_inte: inteTipo === 'I' ? '1' : ''
                })
                .pipe(
                  map((valResp) => this.extraerValorDesdeRespuestaValores(valResp, lookup.prmTari)),
                  catchError(() => of(0))
                );
            }),
            catchError(() => of(0))
          )
      ),
      catchError(() => of(0))
    );
  }

  /** Tarifa "como asociado" siempre consulta plan A, independiente del tipoPlan de la venta (F/E/C/GA). */
  private obtenerTipoPlanFiltroTarifaAsociado(): string {
    return 'A';
  }

  private resolverLookupTarifaAsociadoLegacy(
    legacyResp: ConsultarTarifasIndividualesResponse,
    codigoPrograma: string,
    tipoPlanFiltro: string,
    tarifaSeleccionada?: string
  ): { prmSubcta: string; prmPlanCodi: string; prmTari: string; tariTipo: 'I' | 'C' } | null {
    const rows =
      legacyResp?.status && Array.isArray(legacyResp?.data?.jsonRespuesta)
        ? legacyResp.data!.jsonRespuesta!
        : [];
    const filtradas = rows.filter(
      (it) => (it.TIPO_PLAN ?? '').toString().trim().toUpperCase() === tipoPlanFiltro
    );
    const lista = filtradas.length ? filtradas : rows;
    const prog = codigoPrograma.trim().toUpperCase();
    const tariSel = (tarifaSeleccionada ?? '').toString().trim().toUpperCase();
    // Ej: FSOFEN → ASOFEN para buscar en asociado.
    const tariAsociado = this.aCodigoTarifaAsociado(tariSel);

    const codigoTarifa = (it: { TARIFA_CODIGO?: string | null }): string =>
      (it.TARIFA_CODIGO ?? '').toString().trim().toUpperCase();
    const codigoPlan = (it: { PLAN_CODIGO?: string | null }): string =>
      (it.PLAN_CODIGO ?? '')
        .toString()
        .trim()
        .split('|')[0]
        .trim()
        .toUpperCase();

    const match =
      (tariAsociado
        ? lista.find((it) => codigoTarifa(it) === tariAsociado)
        : undefined)
      ?? (tariSel
        ? lista.find((it) => codigoTarifa(it) === tariSel)
        : undefined)
      ?? lista.find((it) => codigoPlan(it) === prog)
      ?? lista[0];

    if (!match) {
      return null;
    }

    const prmTari = (match.TARIFA_CODIGO ?? '').toString().trim();
    const prmPlanCodi = (match.PLAN_CODIGO ?? '')
      .toString()
      .trim()
      .split('|')[0]
      .trim()
      .toUpperCase();
    const prmSubcta = (match.SUBCUENTA ?? '').toString().trim().toUpperCase();
    const tipoRaw = (match.TARI_TIPO ?? '').toString().trim().toUpperCase();
    const tariTipo: 'I' | 'C' = tipoRaw === 'C' ? 'C' : 'I';

    if (!prmTari || !prmPlanCodi) {
      return null;
    }
    return { prmSubcta, prmPlanCodi, prmTari, tariTipo };
  }

  /** Cambia el prefijo a A para armar el código de asociado. */
  private aCodigoTarifaAsociado(codigo: string): string {
    const c = (codigo ?? '').toString().trim().toUpperCase();
    if (!c) {
      return '';
    }
    if (c.startsWith('A')) {
      return c;
    }
    return c.length > 1 ? `A${c.substring(1)}` : c;
  }

  /** Código de tarifa de la fila. */
  private extraerCodigoTarifaDesdeFila(row: ResumenCotizacionRow): string {
    const directo = (row.modalTarifaCodigo ?? '').toString().trim().toUpperCase();
    if (directo) {
      return directo;
    }
    const desc = (row.modalDescripcionTarifa ?? '').toString().trim();
    if (!desc) {
      return '';
    }
    const mParen = desc.match(/\(([^)]+)\)$/);
    if (mParen?.[1]) {
      return mParen[1].trim().toUpperCase();
    }
    if (desc.includes(' - ')) {
      return desc.split(' - ')[0].trim().toUpperCase();
    }
    return desc.split(/\s+/)[0].trim().toUpperCase();
  }

  private extraerValorDesdeRespuestaValores(
    valResp: ConsultarTarifasIndividualesValoresResponse,
    prmTari: string
  ): number {
    const jsonItems = valResp?.data?.jsonRespuesta ?? [];
    const items = Array.isArray(jsonItems)
      ? jsonItems
      : Array.isArray(valResp?.data?.respuesta)
        ? (valResp.data!.respuesta as Array<{ tari?: string | null; valor?: number | null }>)
        : [];
    const cod = prmTari.trim();
    const hit =
      items.find((it) => (it?.tari ?? '').toString().trim() === cod) ?? items[0];
    return this.parseValorTarifa(hit?.valor);
  }

  private normalizarGenero(genero: string | undefined): string {
    const g = (genero ?? '').trim().toUpperCase();
    return g === 'F' || g === 'FEMENINO' || g === '2' ? 'F' : 'M';
  }

  private guardarParametrosJasperEnStorage(): void {
    try {
      const idCotizacion = this.getIdCotizacionEnCurso();

      if (!idCotizacion) {
        return;
      }

      const raw = localStorage.getItem(
        ResumenCotizacionProgramaComponent
          .KEY_PARAMETROS_JASPER_STORAGE
      );

      const data: Record<string, any> = raw
        ? JSON.parse(raw)
        : {};

      const keyCotizacion = String(idCotizacion);

      const estadoActual =
        data[keyCotizacion] &&
          typeof data[keyCotizacion] === 'object'
          ? data[keyCotizacion]
          : {};

      const programas =
        estadoActual.programas &&
          typeof estadoActual.programas === 'object'
          ? estadoActual.programas
          : {};

      programas[this.programaId] = {
        pCuotaInscripcion:
          this.pCuotaInscripcion,

        pPagoProporcionalAnticipado:
          this.pPagoProporcionalAnticipado,

        pPrecioBaseAnexos:
          this.pPrecioBaseAnexos,

        pTarifaAsociado:
          this.pTarifaAsociado
      };

      const valoresProgramas = Object.values(programas) as Array<{
        pCuotaInscripcion?: string;
        pPagoProporcionalAnticipado?: string;
        pPrecioBaseAnexos?: string;
        pTarifaAsociado?: string;
      }>;

      data[keyCotizacion] = {
        programas,

        pCuotaInscripcion:
          valoresProgramas.some(
            item => item.pCuotaInscripcion === '1'
          )
            ? '1'
            : '0',

        pPagoProporcionalAnticipado:
          valoresProgramas.some(
            item =>
              item.pPagoProporcionalAnticipado === '1'
          )
            ? '1'
            : '0',

        pPrecioBaseAnexos:
          valoresProgramas.some(
            item => item.pPrecioBaseAnexos === '1'
          )
            ? '1'
            : '0',

        pTarifaAsociado:
          valoresProgramas.some(
            item => item.pTarifaAsociado === '1'
          )
            ? '1'
            : '0'
      };

      localStorage.setItem(
        ResumenCotizacionProgramaComponent
          .KEY_PARAMETROS_JASPER_STORAGE,
        JSON.stringify(data)
      );
    } catch (error) {
      console.error(
        'Error guardando parámetros Jasper:',
        error
      );
    }
  }

  private emitirEstadoLiquidacion(): void {
    this.guardarParametrosJasperEnStorage();

    this.estadoLiqudacionChange.emit({
      programaId: this.programaId,
      lineaNegocio: this.lineaNegocio,
      proporcionalidad: this.proporcionalidad,
      fechaIngreso: this.fechaIngreso ? this.fechaIngreso.toISOString() : null,
      diaCorte: this.corte,
      diasProporcionalidad: this.diasProporcionalidad,
      aplicaCuotaInscripcion: this.cuotaInscripcion,
      valorCuotaInscripcion: Number(this.valorPagarCuotaInscripcion || 0),
      aplicacionCuotaPorBeneficiario: this.aplicacionCuotaPorBeneficiario,
      mesesProntoPago: this.prontoPagoMeses,
      columnaValorTabla: this.columnaValorTabla,
      aplicaTarifaAsociado: this.mostrarTarifaAsociado,
      pCuotaInscripcion:
        this.pCuotaInscripcion,
      pPagoProporcionalAnticipado:
        this.pPagoProporcionalAnticipado,
      pPrecioBaseAnexos:
        this.pPrecioBaseAnexos,
      pTarifaAsociado:
        this.pTarifaAsociado,
      rows: [...this.sourceRows]
    });
  }

  private parseValorTarifa(valorRaw: unknown): number {
    if (valorRaw == null) return 0;
    const text = String(valorRaw).trim();
    if (!text) return 0;
    const numeric = Number(text.replace(/[^\d.-]/g, ''));
    if (!Number.isFinite(numeric) || numeric <= 0) return 0;
    return Math.round(numeric);
  }

  private formatearFechaVigencia(fecha: string | null | undefined): string {
    const raw = (fecha ?? '').toString().trim();
    if (!raw) {
      return '';
    }
    const matchIso = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!matchIso) {
      return raw;
    }
    const [, year, month, day] = matchIso;
    return `${day}/${month}/${year}`;
  }

  private sum(key: keyof ResumenCotizacionRow): number {
    return this.dataSource.data.reduce((acc, row) => acc + Number(row[key] || 0), 0);
  }

  private normalize(text: string): string {
    return (text ?? '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  private static guardarCompararEnStorage(): void {
    try {
      const payload: Record<string, string[]> = {};
      ResumenCotizacionProgramaComponent.compararSeleccionadosPorLinea.forEach((set, linea) => {
        payload[linea] = Array.from(set).slice(0, 2);
      });
      localStorage.setItem(ResumenCotizacionProgramaComponent.KEY_COMPARAR_STORAGE, JSON.stringify(payload));
    } catch {
      // No bloquear flujo UI por fallas de storage.
    }
  }

  private static cargarCompararDesdeStorage(): void {
    try {
      const raw = localStorage.getItem(ResumenCotizacionProgramaComponent.KEY_COMPARAR_STORAGE);
      if (!raw) return;
      const parsed = JSON.parse(raw) as Record<string, unknown>;
      if (!parsed || typeof parsed !== 'object') return;

      Object.entries(parsed).forEach(([linea, ids]) => {
        if (!Array.isArray(ids)) return;
        const valid = ids
          .map((id) => String(id ?? '').trim())
          .filter(Boolean)
          .slice(0, 2);
        if (!valid.length) return;
        ResumenCotizacionProgramaComponent.compararSeleccionadosPorLinea.set(linea, new Set(valid));
      });
    } catch {
      // Si el contenido es inválido, no interrumpir la pantalla.
    }
  }

}
